import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagUs = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 1235,
	height: 650,
	viewBox: "0 0 7410 3900",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0,0h7410v3900H0",
			fill: "#bf0a30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0",
			stroke: "#FFF",
			strokeWidth: 300
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0,0h2964v2100H0",
			fill: "#00205b"
		})
	]
});
export default SvgFlagUs;
